import React, { useEffect } from "react";
import { AnalyticsService, AnalyticsAction, AnalyticsFeature } from "../../services/AnalyticsService";
import check from "../../assets/Images/check.png";
import { useLocation } from "react-router-dom";
import "../../assets/css/style.css";
import { useSelector } from "react-redux";
import { SessionState } from "../../redux/sessionSlice";
import {useAsaSession} from '../../services/AsaSessionServices'
import { showCustomToast } from "../../services/toastService";
export default function Confirmation() {
  const location = useLocation();
  const passedData = location.state;
  const {data:session}=useAsaSession()
  const UpdatedLocalData = useSelector(
    (state: SessionState) => state?.session.dynamicLink
  );

  useEffect(() => {
    AnalyticsService.track(
      passedData === "already" ? "CRB Payment Already Registered Viewed" : "CRB Payment Confirmation Viewed",
      AnalyticsAction.View,
      AnalyticsFeature.CRB,
    );
    setTimeout(() => {
            let successDynamicLink = null;
            const targetPage = session?.sessionPages?.find(page => page.pageNumber === 0);
            if (targetPage) {
              const pageData = JSON.parse(targetPage.pageData);
              successDynamicLink = pageData.successDynamicLink;
            }
            if (successDynamicLink) {
              window.location.href = successDynamicLink;
              window.close();
            } else {
              showCustomToast("Payment is done, but we can't navigate back. Try to use application", true);
            }

    }, 12000); // 5000 milliseconds = 5 seconds
  }, []);

  const renderContent = () => {
    if (
      passedData ==="already" ) {
      return (
        <>
          <p className="text-center text-2xl poppins-semibold text-white leading-8">
            {"Payment already registered!"}
          </p>
          <p className="text-center poppins-medium text-white leading-8 mt-8">
            Thank you for your payment. Your transaction has already been
            processed.
          </p>
          <div className="center-content">
            <img
              src={check}
              className="w-28 h-28 sm:w-56 sm:h-56 mt-4 sm:mt-8"
              alt="Success Icon"
            />
          </div>
          {/* Apply the custom CSS class */}
        </>
      );
    } else {
      return (
        <>
          <p className="text-center text-2xl poppins-semibold text-white leading-8">
            Payment Successful!
          </p>
          <p className="text-center poppins-medium text-white leading-8 mt-5 ml-5 mr-5">
            {"Thank you for your Payment! Congratulations on taking a very important step to improve your credit score. We are working with your information to create an update on your credit report. You should receive an email within a day or two updating you on our progress as well as regular updates as we work with the credit bureaus."}
          </p>
          <div className="center-content">
            <img
              src={check}
              className="w-28 h-28 sm:w-56 sm:h-56 mt-4 sm:mt-8"
              alt="Success Icon"
            />
          </div>
        </>
      );
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-image-confirmation">
      <div className="grid mx-7 my-7">{renderContent()}</div>
    </div>
  );
}
